import { render, staticRenderFns } from "./SpeenComponent.vue?vue&type=template&id=fcc71a90&"
import script from "./SpeenComponent.vue?vue&type=script&lang=js&"
export * from "./SpeenComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports